import { Box, Chip, styled } from '@mui/material';
import React from 'react';

const StyledChip = styled(Chip)(({ theme }) => ({
	marginRight: theme.spacing(1)
}));

const Label = ({ label, ...rest }) => {
	return <StyledChip label={label} {...rest} />;
};

export default Label;
